import Vue from 'vue'
import router from './router/index.js'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import '@/common/common.css'
import '@/common/home.css'
import '@/plugins/axios/axiosUtil.js'
//引入富文本编辑器 quill-editor
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
// import moment from 'moment'
// Vue.use(moment)
Vue.use(VueQuillEditor);

Vue.config.productionTip = false
Vue.use(ElementUI)


/*全局注册draggable可拖动组件*/
import draggable from 'vuedraggable'
Vue.component('draggable', draggable)

// 弹窗拖拽
// v-dialogDrag: 弹窗拖拽
Vue.directive('dialogDrag', {
    bind(el, binding, vnode, oldVnode) {
        const headerElement = el.querySelector('.el-dialog__header')
        const dragDialog = el.querySelector('.el-dialog')
        headerElement.style.cursor = 'move'

        // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
        const sty = dragDialog.currentStyle || window.getComputedStyle(dragDialog, null)

        headerElement.onmousedown = (e) => {

            // 鼠标按下，计算当前元素距离可视区的距离
            const disX = e.clientX - headerElement.offsetLeft
            const disY = e.clientY - headerElement.offsetTop
                // 获取到的值带px 正则匹配替换
            let styL, styT

            // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
            if (sty.left.includes('%')) {
                styL = +document.body.clientWidth * (+sty.left.replace(/\%/g, '') / 100)
                styT = +document.body.clientHeight * (+sty.top.replace(/\%/g, '') / 100)
            } else {
                styL = +sty.left.replace(/\px/g, '') // 写成/px/g 也行
                styT = +sty.top.replace(/\px/g, '')
            }

            document.onmousemove = function(e) {
                // 通过事件委托，计算移动的距离
                const l = e.clientX - disX
                const t = e.clientY - disY
                    // 移动当前元素
                dragDialog.style.left = `${l + styL}px`
                dragDialog.style.top = `${t + styT}px`

                // 将此时的位置传出去
                // binding.value({x:e.pageX,y:e.pageY})
            }

            document.onmouseup = function(e) {
                document.onmousemove = null
                document.onmouseup = null
            }
        }
    }
})

// 全局路由守卫
import './router/permission'
import store from './store'
window.$store = store;
window.$router = router;

new Vue({
    router,
    store,
    render: h => h(App),

}).$mount('#app')